// Builds select to handle us-map state selections on mobile devices

const buildStateSelect = () => {
    // Create the <select> and initial disabled <option>
    const select = document.createElement('select');
    const initOption = document.createElement('option');
    const span = document.createElement('span');

    initOption.textContent = 'Select Your State';
    initOption.setAttribute('disabled', true);
    initOption.setAttribute('selected', true);

    select.appendChild(initOption);

    // Start the states array
    const states = [];

    const statesParent = document.querySelector('[data-us-map-select]');
    const stateLinks = statesParent.querySelectorAll('a');

    Array.prototype.forEach.call(stateLinks, (el) => {
        states.push(el);
    });

    // Build and append each <option>
    states.forEach((item) => {
        const option = document.createElement('option');
        const href = item.getAttribute('href');

        option.textContent = item.textContent;
        option.setAttribute('value', href);

        select.appendChild(option);
        select.className = 'show-for-small-only';
    });
    span.className = 'arrow-down';
    document.querySelector('[data-us-map]').appendChild(select);
    document.querySelector('[data-us-map]').appendChild(span);
    statesParent.parentNode.removeChild(statesParent);

    select.addEventListener('change', (e) => {
        window.location.href = e.target.value;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            component: 'US Map',
        });
    });
};

// Module startup
const init = () => {
    if (document.querySelector('[data-us-map]') !== null) {
        buildStateSelect();
    }
};

export { init };
